import { render, staticRenderFns } from "./Tecnologia.vue?vue&type=template&id=eb4a640c&"
import script from "./Tecnologia.vue?vue&type=script&lang=js&"
export * from "./Tecnologia.vue?vue&type=script&lang=js&"
import style0 from "./Tecnologia.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports